import "./EphemeralBanner.css";
import React from "react";
import PropTypes from "prop-types";
import ContentItem from "shared/components/cms/ContentItem";

export default class EphemeralBanner extends React.Component {

    static propTypes = {
        ctaLink: PropTypes.string,
        ctaText: PropTypes.string,
        bannerHeader: PropTypes.string,
        bannerText: PropTypes.string,
        ctaOpenInNewTab: PropTypes.bool,
        ctaVisible: PropTypes.bool
    };

    render() {
        const {
            ctaLink,
            ctaText,
            bannerHeaderContentKey,
            bannerMessageContentKey,
            ctaOpenInNewTab,
            ctaVisible
        } = this.props;

        return (
            <section className="ephemeral-banner">
                <div className="ephemeral-banner-content-wrapper">
                    <div className="ephemeral-banner-text-wrapper">
                        <ContentItem className="ephemeral-banner-header" contentKey={bannerHeaderContentKey} />
                        <ContentItem className="ephemeral-banner-text" contentKey={bannerMessageContentKey} />
                    </div>
                    <div className="cta-button-container">
                        {ctaVisible && <a className="ctaButton" target={ctaOpenInNewTab ? "_blank" : "_self"} href={ctaLink}>{ctaText}</a>}
                    </div>
                </div>
            </section>
        );
    }
}
